import React, { useRef, useCallback, useState, useEffect } from 'react';

import * as S from './styles';
import { FetchEmbedZohoActions } from 'store/ducks/zohoDashboard';
import { useDispatch, useSelector } from 'react-redux';

const ControlTower: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    if (ref.current) {
      if (window.document.fullscreenElement) {
        if (window.document.exitFullscreen) {
          window.document.exitFullscreen();
        }
      } else {
        ref.current.requestFullscreen();
      }
    }
  }, []);

  const handleKeyDown = useCallback(() => {
    setIsFullscreen((v) => !v);
  }, []);

  useEffect(() => {
    if (window.document) {
      window.document.addEventListener('fullscreenchange', handleKeyDown);
    }

    return () => {
      window.document.removeEventListener('fullscreenchange', handleKeyDown);
    };
  }, [handleKeyDown]);

  const getDashboardUrl = useCallback((view: string) => {
    dispatch(FetchEmbedZohoActions.request(view));
  }, [dispatch])

  const { data: zohoEmbedUrl , loading } = useSelector(
    (state:any) => state.fetchEmbedZohoUrl
  );

  useEffect(() => {
    getDashboardUrl('1432280000166263253');
  }, []);
  
  return (
    <S.Container ref={ref}>
      <S.Button onClick={handleClick}>
        {isFullscreen ? <S.IconExitFullscreen /> : <S.IconFullscreen />}
      </S.Button>
      {loading ?
        (
          <S.Loading />
        ) : (
          <iframe
            width="100%"
            height="100%"
            src={zohoEmbedUrl?.data?.embedUrl}
            title="Control Tower"
          /> 
        )
      }       
    </S.Container>
  );
};

export { ControlTower };
